/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { CategoryData, CategoryDataAces } from '@/features/category';
import { getShelfBodyParts } from './getShelfBodyparts';
import { normalizeShelfResponse } from './normalizeShelfResponse';
import { type CitrusCarouselResponse } from '@/features/citrus';

export const getSkuIdsForPage = (
  pageData: CategoryData | undefined | CategoryDataAces,
  pathname: string,
  citrusData: CitrusCarouselResponse | undefined,
): {
  skuIds: string[];
  sponsoredSkus: string[];
  resultSkus: string[];
} => {
  const { shelfPageBody } = normalizeShelfResponse({
    data: pageData,
    pathname: pathname,
  });
  const citrusSponsoredSkus =
    citrusData?.ads
      .slice(0, 3)
      .map((ad) => ad.gtin)
      .filter(Boolean) ?? [];

  const shelfBodyParts = getShelfBodyParts(shelfPageBody);
  const skuIds =
    shelfBodyParts.resultsList?.records?.map((record) => record.skuNumber.toString()) ?? [];

  const allSkus = new Set([...citrusSponsoredSkus]);

  const resultSkus: string[] = [];

  // Remove duplicate SKU IDs
  for (const sku of skuIds) {
    if (!allSkus.has(sku)) {
      allSkus.add(sku);
      resultSkus.push(sku);
    }
  }

  return {
    skuIds: Array.from(allSkus),
    sponsoredSkus: citrusSponsoredSkus,
    resultSkus,
  };
};
